import { render, staticRenderFns } from "./exberror.vue?vue&type=template&id=8e790e08&scoped=true"
import script from "./exberror.vue?vue&type=script&lang=js"
export * from "./exberror.vue?vue&type=script&lang=js"
import style0 from "./exberror.vue?vue&type=style&index=0&id=8e790e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e790e08",
  null
  
)

export default component.exports